/**
 * Created by rhinov8e on 18/11/2015.
 */
import { FrontViewNode } from "./Nodes/FrontViewNode";
import { FrontViewAreaNode } from "./Nodes/FrontViewAreaNode";

import { PlanManager } from "../../../cocosPlan";
import { Area, Coating, Entity, Joinery, math, SavaneConstants, SceneConstants, TechnicalElement } from "@rhinov/savane-js";

export class FrontViewManager {
    static updateDecoration(obj: Entity, adding?: boolean) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName('deco' + obj.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;
        var wall: any = PlanManager.getInstance().frontViewLayer.currentWall!;

        if (model === null && layer !== null) {
            //make sure it is the currentWall display on the frontview! => case of undo
            var isInCurrentWall = false;

            if (adding !== true) {
                if (obj instanceof Joinery && wall !== null) {
                    isInCurrentWall = obj.wall.id === wall.id;
                }
                else {
                    var wallObj;

                    if (obj.isTechnicalElementEntity()) {
                        wallObj = PlanManager.getInstance().world.currentScene!.currentFloor!.getWallTechnicalElements(wall.id,
                            PlanManager.getInstance().frontViewLayer.isDirectSide,
                            5 * SavaneConstants.PositionTolerance);
                    }
                    else {
                        wallObj = PlanManager.getInstance().world.currentScene!.currentFloor!.getWallDecorations(wall.id,
                            PlanManager.getInstance().frontViewLayer.isDirectSide,
                            5 * SavaneConstants.PositionTolerance);
                    }

                    for (var i = 0; i < wallObj.length; ++i) {
                        if (obj.id === wallObj[i].id) {
                            isInCurrentWall = true;
                            break;
                        }
                    }
                }
            } else {
                isInCurrentWall = true;
            }

            if (isInCurrentWall && layer !== null && scale !== null) {
                //create and add node
                if (!obj.isArrangementGroupEntity() && !obj.isArrangementZoneEntity()) {
                    var createdItem = new FrontViewNode(obj, scale);
                    layer.addChild(createdItem, 20);
                    createdItem.setVisible(true);
                    createdItem.update(scale);
                    createdItem.setVisible(!PlanManager.getInstance()._hideArrangements);
                }
            }
        } else if (model !== null) {
            if (model._obj.isArrangementObjectEntity()) {
                model.setVisible(!PlanManager.getInstance()._hideArrangements);
            }
            model.update(scale!);
        }

        if (obj.children) {
            for (var i = 0 ; i < obj.children.length ; i++) {
                this.updateDecoration(obj.children[i], adding);
            }
        }
    };

    static drawArea(obj: any, adding: any, edit: any, editedPoint: any, editedLine: any, SVG?: any) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName('areaCoatingNode' + obj.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;
        var isDirectSide: any = PlanManager.getInstance().frontViewLayer.isDirectSide;
        var wall: any = PlanManager.getInstance().frontViewLayer.currentWall;

        if (model === null) {
            //make sure it is the currentWall display on the frontview! => case of undo
            var isInCurrentWall = false;

            if (adding === true) {
                isInCurrentWall = true;
            } else {
                if (wall !== null && wall.id === obj.entity.id && isDirectSide === obj.isDirectSide) {
                    isInCurrentWall = true;
                }
            }

            if (isInCurrentWall && layer !== null) {
                //create and add node
                var createdItem = new FrontViewAreaNode(obj, scale, edit, editedPoint, SVG);
                layer.addChild(createdItem, 10);
                createdItem.setVisible(true);
                createdItem.update(scale!, !adding);
            }
        }
        else {
            model.setEdit(edit, editedPoint, editedLine);
            model.setVisible(true);
            model.update(scale!, adding);
        }
    };
    static generateName(obj: Entity): string {
        var name = 'unknown';
        if (obj instanceof Joinery) {
            switch (obj.joineryType) {
                case SceneConstants.JoineryType.door:
                    name = 'Porte';
                    break;
                case SceneConstants.JoineryType.opening:
                    name = 'Ouverture';
                    break;
                case SceneConstants.JoineryType.window:
                    name = 'Fenêtre';
                    break;
                case SceneConstants.JoineryType.frenchWindow:
                    name = 'Porte Fenêtre';
                    break;
                case SceneConstants.JoineryType.pictureWindow:
                    name = 'Baie Vitrée';
                    break;
                case SceneConstants.JoineryType.fixedWindow:
                    name = 'Châssis Fixe';
                    break;
                case SceneConstants.JoineryType.velux:
                    name = 'Vélux';
                    break;
                case SceneConstants.JoineryType.canopy:
                    name = 'Verrière';
                    break;
                case SceneConstants.JoineryType.cupboardDoor:
                    name = 'Porte de Placard';
                    break;
                case SceneConstants.JoineryType.garageDoor:
                    name = 'Porte de Garage';
                    break;
                case SceneConstants.JoineryType.frontDoor:
                    name = 'Porte d\'Entrée';
                    break;
                case SceneConstants.JoineryType.niche:
                    name = 'Niche';
                    break;
                default:
                    name = 'Déco';
            }
        }
        if (obj.isTechnicalElementEntity()) {
            switch ((obj as TechnicalElement).objectId) {
                case SceneConstants.TechnicalElementType.pole:
                    name = 'Poteau';
                    break;
                case SceneConstants.TechnicalElementType.stove:
                    name = 'Poêle';
                    break;
                case SceneConstants.TechnicalElementType.fireplace:
                    name = 'Cheminée';
                    break;
                case SceneConstants.TechnicalElementType.radiator:
                    name = 'Radiateur';
                    break;
                case SceneConstants.TechnicalElementType.serviceShaft:
                    name = 'Gain technique';
                    break;
                case SceneConstants.TechnicalElementType.boiler:
                    name = 'Chaudière';
                    break;
                case SceneConstants.TechnicalElementType.waterSource:
                    name = 'Point d\'eau';
                    break;
                case SceneConstants.TechnicalElementType.ceilingBox:
                    name = 'Vélux';
                    break;
                case SceneConstants.TechnicalElementType.switchBoard:
                    name = 'Tableau Elec';
                    break;
                case SceneConstants.TechnicalElementType.socketTV:
                    name = 'Prise TV';
                    break;
                case SceneConstants.TechnicalElementType.socketSixteen:
                    name = 'Prise 16A';
                    break;
                case SceneConstants.TechnicalElementType.socketThirtyTwo:
                    name = 'Prise 32A';
                    break;
                case SceneConstants.TechnicalElementType.wardRobe:
                    name = 'Garde robe';
                    break;
                case SceneConstants.TechnicalElementType.airConditioner:
                    name = 'Climatisation';
                    break;
                case SceneConstants.TechnicalElementType.spotLight:
                    name = 'Spot';
                    break;
                case SceneConstants.TechnicalElementType.beam:
                    name = 'Poutre';
                    break;
                case SceneConstants.TechnicalElementType.frame:
                    name = 'Charpente';
                    break;
                case SceneConstants.TechnicalElementType.rosette:
                    name = 'Rosace';
                    break;
                case SceneConstants.TechnicalElementType.guardrail:
                    name = 'Garde corps';
                    break;
                case SceneConstants.TechnicalElementType.wallDecoration:
                    name = 'Décoration murale';
                    break;
            }
        }
        return name;
    };
    static unselectDecoration(deco: Entity | Area | Coating) {
        if (!deco) {
            return;
        }

        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName(((deco as Entity).entityType !== undefined ? 'deco' : 'areaCoatingNode') + deco.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;

        if (model !== null && scale !== null) {
            model.selected = false;
            model.update(scale);
        }

        if ((deco as Entity).children) {
            for (var i = 0 ; i < (deco as Entity).children.length ; i++) {
                this.unselectDecoration((deco as Entity).children[i]);
            }
        }
    };
    static selectDecoration(deco: Entity | Area) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName(((deco as Entity).entityType !== undefined ? 'deco' : 'areaCoatingNode') + deco.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;

        if (model !== null && scale !== null) {
            model.selected = true;
            model.update(scale);
        }

        if ((deco as Entity).children) {
            for (var i = 0 ; i < (deco as Entity).children.length ; i++) {
                this.selectDecoration((deco as Entity).children[i]);
            }
        }
    };
    static setValidity(deco: Entity, isValid: boolean) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName((deco.entityType !== undefined ? 'deco' : 'areaCoatingNode') + deco.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;

        if (model !== null && scale !== null) {
            model.valid = isValid;
            model.update(scale);
        }
    };
    static setAreaValidity(deco: Entity | Area, isValid: boolean) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName(((deco as Entity).entityType !== undefined ? 'deco' : 'areaCoatingNode') + deco.id) : null;

        if (model !== null) {
            model.valid = isValid;
        }
    };
    static deleteDeco(deco: Entity) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var node = layer !== null ? layer.getChildByName('deco' + deco.id) : null;
        if (node !== null) {
            node.removeFromParent();
        }

        if (deco.children) {
            for (var i = 0 ; i < deco.children.length ; i++) {
                this.deleteDeco(deco.children[i]);
            }
        }
    };
    static deleteJoinery(id: number) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var node = layer !== null ? layer.getChildByName('deco' + id) : null;
        if (node !== null) {
            node.removeFromParent();
        }
    };
    static deleteArea(id: number) {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var node = layer !== null ? layer.getChildByName('areaCoatingNode' + id) : null;
        if (node !== null) {
            node.removeFromParent();
        }
    };
    static toResize(cursorPosition: math.vec3, entitySelected: Entity): boolean {
        var layer: any = PlanManager.getInstance().frontViewLayer.node;
        var model = layer !== null ? layer.getChildByName('deco' + entitySelected.id) : null;
        var scale: number | null = PlanManager.getInstance().frontViewLayer._scale;
        var scalable = true;
        if (entitySelected instanceof Joinery) {
            scalable = entitySelected.scalable;
        }

        if (model !== null && scalable && scale !== null) {
            return model.toResize(cursorPosition, scale);
        }
        return false;
    };
}

/**
 * Create an instance of the designated item and add it on the grid
 * @param arrangement {IArrangement}
 * @param adding {boolean} : if true , won't test if the deco is really on the wall
 * @returns {ArrangementSprite} Created component
 */

